import { Component, Input, computed, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SellerInfo } from '../../order-v2.types';
import { ClipboardService } from '../../../../../core/services/clipboard/clipboard.service';

interface SellerField {
  label: string;
  value: string | null | undefined;
}

@Component({
  selector: 'app-seller-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="rounded-2xl border border-neutral-200 bg-white p-4 shadow-sm dark:border-neutral-800 dark:bg-neutral-800/40">
      <div class="overflow-hidden">
        <div class="mb-2.5 text-lg font-semibold text-neutral-900 dark:text-white">vendedor</div>
        @for (field of fields(); track field.label) {
          <div class="flex items-start gap-1.5 py-0.5 text-sm text-neutral-900 dark:text-neutral-100">
            <button
              type="button"
              (click)="copyValue(field.value)"
              [title]="'Copiar ' + field.label"
              class="flex min-w-[80px] shrink-0 cursor-pointer items-center bg-transparent p-0 text-left text-xs text-neutral-500 focus-visible:outline-none dark:text-neutral-400"
            >
              <span class="truncate">{{ field.label }}</span>
            </button>
            <span class="min-w-0 flex-1 break-words">{{ field.value }}</span>
          </div>
        }
      </div>
    </div>
  `,
})
export class SellerCardComponent {
  @Input({ required: true }) seller!: SellerInfo;

  private readonly _clipboard = inject(ClipboardService);

  readonly fields = computed<SellerField[]>(() => {
    const s = this.seller;
    if (!s) return [];
    const items: SellerField[] = [
      { label: 'Nome', value: s.name },
      { label: 'ID', value: s.id },
      { label: 'Tabela', value: s.priceTable },
      { label: 'Caixa', value: s.cashierNumber },
      { label: 'Loja', value: s.cashierStoreId },
    ];
    return items.filter((f) => f.value !== null && f.value !== undefined && String(f.value).trim().length > 0);
  });

  copyValue(value: string | null | undefined): void {
    if (value === null || value === undefined) return;
    this._clipboard.copy(String(value));
  }
}
